import { FilterConditionOperation } from "../components/LayerFilter/types";

export const isConditionSpecialFunc = (condition: string): boolean => {
  const conditionSplit = condition?.split(FilterConditionOperation.AND) ?? [];

  return conditionSplit.some(item => item.trim().match(/^!*intersect.*$/));
};
